import { openBlock as l, createElementBlock as e, createElementVNode as t } from "vue";
const o = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 40"
}, n = /* @__PURE__ */ t("path", {
  fill: "#338AF3",
  d: "M18.26 21.74S5.87 5.854 5.859 5.857A19.937 19.937 0 0 1 20 0c11.046 0 20 8.954 20 20l-21.74 1.74Z"
}, null, -1), c = /* @__PURE__ */ t("path", {
  fill: "#6DA544",
  d: "M18.26 20S5.87 34.145 5.859 34.142A19.937 19.937 0 0 0 20 40c11.046 0 20-8.954 20-20H18.26Z"
}, null, -1), s = /* @__PURE__ */ t("path", {
  fill: "#F0F0F0",
  d: "M5.858 5.858c-7.81 7.81-7.81 20.473 0 28.284L20 20 5.858 5.858Z"
}, null, -1), i = /* @__PURE__ */ t("path", {
  fill: "#D80027",
  d: "m8.095 14.783 1.295 3.985h4.19l-3.39 2.464 1.295 3.985-3.39-2.463-3.39 2.463 1.294-3.985-3.39-2.464h4.19l1.296-3.985Z"
}, null, -1), d = [
  n,
  c,
  s,
  i
];
function h(_, r) {
  return l(), e("svg", o, [...d]);
}
const f = { render: h };
export {
  f as default,
  h as render
};
